<template>
  <footer class="bg-secondary-dark pb-10 lg:pb-12">
    <div class="container__fullwidth space-y-10 lg:space-y-36">
      <AppFooterNavigation />
      <AppFooterBranding />
    </div>
  </footer>
</template>
